import React, { useState } from "react";
import logo from "../../Images/LogoMinhaBunge.png";
import CustomLink from "../CustomLink";
import { Container, NavHeander, Logo, LinkHeander } from "./styles";
import Simulador from "../Simulador";
import { URLBunge } from "../../Componentes/Config";
import Carregando from "../../Componentes/Carregando";

function HeaderPortalVendedor() {
  const departamento =
    localStorage.getItem("@p_departamento-numero") === null
      ? 10
      : localStorage.getItem("@p_departamento-numero");

  const token = localStorage.getItem("c_token");
  const cpf = localStorage.getItem("c_cpf");
  const id = 0;
  const [Loading, setLoading] = useState(false)
  const [mostraMenuResposivo, setMostraMenuResponsivo] = useState(false);
  const [abreModalSimulador, setAbreModalSimulador] = useState(false);

  function lidaComMenuResposivo() {
    setMostraMenuResponsivo((oldValues) => !oldValues);
  }

  async function RedirecionaCatalogo() {
    setLoading(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + token);
    myHeaders.append("Content-Type", "application/json");

    var dados = {
      idProjeto: 2329681,
      cpfCliente: cpf,
    };
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(dados),
      redirect: "follow",
    };

    fetch(`${URLBunge}/api/Globo/Logon`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.sucesso) {
          setLoading(false);
          window.location.href = 
            "http://www.fornadadevantagens.com.br/AppParaCatalogo/" +
              result.refresh_token +
              "/ /Catalogo"
          ;
        }
      })
      .catch((error) => console.log("error", error));
  }

  return (
    <Container>
      {abreModalSimulador && (
        <Simulador setAbreModalSimulador={setAbreModalSimulador} />
      )}
      {Loading === true ? <Carregando /> : null}
      <Logo src={logo} />
      <NavHeander className={mostraMenuResposivo ? "active" : ""}>
        <button onClick={lidaComMenuResposivo} id="btn-mobile__portal">
          <span id="hamburger"></span>
        </button>

        <div id="link-menu">
          <LinkHeander id="link-container">
            <CustomLink
              fechaMenu={() => setMostraMenuResponsivo(false)}
              icone="AiOutlineFileSearch"
              to="/ConsultarCadastros"
              label="Consulta de cadastros"
              activeOnlyWhenExact={true}
            />
          </LinkHeander>

          {departamento === "11" ? (
            <>
              <LinkHeander id="link-container">
                <CustomLink
                  fechaMenu={() => setMostraMenuResponsivo(false)}
                  icone="FaUsers"
                  to="/VendedorUsers"
                  label="Usuários"
                />
              </LinkHeander>

              <LinkHeander id="link-container">
                <CustomLink
                  fechaMenu={() => setMostraMenuResponsivo(false)}
                  icone="IoStorefrontOutline"
                  to="/VendedorLojas"
                  label="Lojas"
                />
              </LinkHeander>

              {/* <LinkHeander id="link-container">
                <CustomLink
                  fechaMenu={() => setMostraMenuResponsivo(false)}
                  icone="IoTicketOutline"
                  to="/PromocodeAdmin"
                  label="Cupons"
                />
              </LinkHeander> */}

              <LinkHeander id="link-container">
                <CustomLink
                  fechaMenu={() => setMostraMenuResponsivo(false)}
                  icone="RiQuestionnaireLine"
                  to="/Questionario"
                  label="Questionários"
                />
              </LinkHeander>

              <LinkHeander id="link-container">
                <CustomLink
                  fechaMenu={() => setMostraMenuResponsivo(false)}
                  icone="FaUsersCog"
                  to="/Comercial"
                  label="Comercial"
                />
              </LinkHeander>
            </>
          ) : (
            <>
              <LinkHeander
                onClick={() => setAbreModalSimulador(true)}
                id="link-container"
              >
                <CustomLink
                  fechaMenu={() => setMostraMenuResponsivo(false)}
                  icone="CgCalculator"
                  // to="/Simulador"
                  label="Simulador"
                />
              </LinkHeander>

              <LinkHeander id="link-container">
                <CustomLink
                  fechaMenu={() => setMostraMenuResponsivo(false)}
                  icone="AiOutlineUserAdd"
                  to="/Proprietario"
                  label="Cadastro de Proprietário"
                />
              </LinkHeander>

              {/* <LinkHeander id="link-container">
                <CustomLink
                  fechaMenu={() => setMostraMenuResponsivo(false)}
                  icone="HiOutlineTicket"
                  to="/Cupons"
                  label="Cupons"
                />
              </LinkHeander> */}

              <LinkHeander id="link-container">
                <CustomLink
                  redirect={RedirecionaCatalogo}
                  fechaMenu={() => setMostraMenuResponsivo(false)}
                  icone="AiOutlineShoppingCart"
                  // onClick={() => RedirecionaCatalogo()}
                  // to="/Catalogo"
                  label="Catálogo"
                />
              </LinkHeander>
            </>
          )}
        </div>
      </NavHeander>
    </Container>
  );
}

export default HeaderPortalVendedor;
